import jsCookie from 'js-cookie';
import { useEffect, useState } from 'react';
import { IGeoBodyParameters, IGeoState } from 'organisms/GeoPopup/types';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { geoCookieName } from './constants';
import { getGeoLocation } from './utils';

export const useGeoPopup = (): IGeoState => {
  const { country } = useSiteConfig();

  return useGeoPopupBody({
    getGeoLocation,
    jsCookie,
    domainCountry: country,
  });
};

export const useGeoPopupBody = ({
  getGeoLocation,
  jsCookie,
  domainCountry,
}: IGeoBodyParameters): IGeoState => {
  const [state, setState] = useState<IGeoState>({ show: false });

  useEffect(() => {
    !!domainCountry &&
      getGeoLocation(domainCountry).then((response) => {
        if (!!response) {
          setState({
            show: true,
            countryCode: response.clientCountryCode,
            redirectUrl: `${response.domainUrl + window?.location.pathname}`,
            action: () => {
              jsCookie.set(geoCookieName, 'true');
              setState((prevState) => ({ ...prevState, show: false }));
            },
          });
        }
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domainCountry]);

  return state;
};
